var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['checkbox', _vm.checked==true?'--active':''],on:{"click":function($event){return _vm.toggle()}}},[(_vm.checked)?_c('InlineSvg',{attrs:{"src":require('@/assets/img/icons/checked.svg')}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }